<div class="material-page" *ngIf="chats">
  <div class="mdc-layout-grid">
    <div class="mdc-layout-grid__inner">
      <div class="left mdc-layout-grid__cell mdc-layout-grid__cell--span-2-desktop mdc-layout-grid__cell--span-2-tablet mdc-layout-grid__cell--span-4-phone">
        <compact-listing-image [item]="chats[0].itemToSell"></compact-listing-image>
      </div>
      <div class="left mdc-layout-grid__cell mdc-layout-grid__cell--span-7-desktop mdc-layout-grid__cell--span-6-tablet mdc-layout-grid__cell--span-4-phone">
        <compact-listing-description [item]="chats[0].itemToSell"></compact-listing-description>
      </div>
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
        <compact-listing-buttons [item]="chats[0].itemToSell" [editNextPage]="router.url"/>
      </div>
      <div class="left gallery-or-icon mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
        <mat-divider></mat-divider>
      </div>  
      <div class="left gallery-or-icon mdc-layout-grid__cell mdc-layout-grid__cell--span-8">
        
        <mat-card *ngFor="let chat of chats" style="margin-bottom: 16px;"
        >
          <mat-card-header>
            <mat-card-subtitle class="mat-subtitle-2">
              <a [routerLink]="['/chats/listings/' + this.itemToSellId + '/chats/' + chat.id]">
                <b style="text-overflow: ellipsis;">{{getWhoWritesToWhomHumanReadable(chat)}}</b>
                <span [style.font-weight]="chat.lastMessage!.unread ? 'bold' : 'normal'" style="text-wrap: nowrap"
                     [matBadge]="chat.unreadMessages" [matBadgeHidden]="chat.unreadMessages === 0" matBadgeColor="accent">
                   {{getHumanReadableMessageTimestamp(chat.lastMessage!.createdTime)}}
                </span>
              </a>
            </mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <a [routerLink]="['/chats/listings/' + this.itemToSellId + '/chats/' + chat.id]">
              <div class="mat-subtitle-2" *ngIf="(chat.totalMessages - 1) > 0" style="text-align: center;margin-top: 16px; margin-bottom: 16px" i18n>*** {{chat.totalMessages - 1}} messages more ***</div>
              <div>{{chat.lastMessage!.message}}</div>
            </a>
          </mat-card-content>
        </mat-card>
        
      </div>
    </div>
  </div>
</div>